(() => {
  document.documentElement.classList.add('js');
  document.querySelectorAll('[data-navigation-toggle]').forEach(button => { button.hidden = false; });
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-navigation-toggle]').forEach(button => { button.hidden = false; });
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-navigation-toggle]');
    if (button) {
      const nav = document.getElementById(button.getAttribute('aria-controls'));
      if (!nav) return;
      const open = nav.classList.toggle('open');
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      button.textContent = open ? '×' : '☰';
    }
    const navLink = event.target.closest('.nav a');
    if (navLink) {
      navLink.closest('.nav').classList.remove('open');
      document.querySelectorAll('[data-navigation-toggle]').forEach(toggle => {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open navigation');
        toggle.textContent = '☰';
      });
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const openNav = document.querySelector('.nav.open');
      if (openNav) {
        const toggle = document.querySelector('[data-navigation-toggle]');
        toggle?.click();
        toggle?.focus();
      }
    }
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-picker]');
    if (!select) return;
    const form = select.closest('form');
    const option = select.selectedOptions[0];
    if (!form || !option) return;
    const price = form.querySelector('[data-variant-price]');
    if (price) price.textContent = option.dataset.price;
    const add = form.querySelector('[data-add-to-cart]');
    if (add) {
      add.disabled = option.dataset.available !== 'true';
      add.textContent = add.disabled ? 'Sold out' : 'Add to basket';
    }
  });

  class JuiceMenu extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.category = 'All drinks';
      this.selected = new Set();
      this.cards = Array.from(this.querySelectorAll('[data-drink-card]'));
      this.query = this.querySelector('[data-menu-query]');
      this.taste = this.querySelector('[data-menu-taste]');
      this.dialog = this.querySelector('[data-shortlist-dialog]');
      this.querySelectorAll('[data-menu-controls],[data-shortlist-toggle]').forEach(element => { element.hidden = false; });
      this.addEventListener('click', event => this.handleClick(event), {signal: this.abort.signal});
      this.query.addEventListener('input', () => this.filter(), {signal: this.abort.signal});
      this.taste.addEventListener('change', () => this.filter(), {signal: this.abort.signal});
      this.filter();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      if (this.dialog?.open) this.dialog.close();
    }
    filter() {
      const query = this.query.value.trim().toLowerCase();
      const taste = this.taste.value;
      let count = 0;
      for (const card of this.cards) {
        card.hidden = !((this.category === 'All drinks' || card.dataset.category === this.category) && (taste === 'Any flavour' || card.dataset.taste === taste) && (!query || card.dataset.search.includes(query)));
        if (!card.hidden) count++;
      }
      this.querySelector('[data-menu-count]').textContent = `${count} ${count === 1 ? 'drink' : 'drinks'} to explore`;
      this.querySelector('[data-menu-empty]').hidden = count !== 0;
      this.querySelectorAll('[data-category-filter]').forEach(button => {
        const active = button.dataset.categoryFilter === this.category;
        button.setAttribute('aria-pressed', String(active));
        button.dataset.state = active ? 'active' : 'inactive';
      });
      this.querySelectorAll('[data-menu-reset]').forEach(button => {
        button.disabled = !query && taste === 'Any flavour' && this.category === 'All drinks';
      });
    }
    handleClick(event) {
      const category = event.target.closest('[data-category-filter]');
      if (category) { this.category = category.dataset.categoryFilter; this.filter(); }
      if (event.target.closest('[data-menu-reset]')) {
        this.category = 'All drinks'; this.query.value = ''; this.taste.value = 'Any flavour'; this.filter();
      }
      const toggle = event.target.closest('[data-shortlist-toggle]');
      if (toggle) this.toggle(toggle.closest('[data-drink-card]').dataset.drinkId);
      const remove = event.target.closest('[data-shortlist-remove]');
      if (remove) {
        const nextButton = remove.closest('li')?.nextElementSibling?.querySelector('button') || remove.closest('li')?.previousElementSibling?.querySelector('button');
        const nextId = nextButton?.dataset.shortlistRemove;
        this.toggle(remove.dataset.shortlistRemove);
        const next = Array.from(this.querySelectorAll('[data-shortlist-remove]')).find(button => button.dataset.shortlistRemove === nextId);
        (next || this.querySelector('[data-shortlist-close]')).focus();
      }
      if (event.target.closest('[data-shortlist-review]')) {
        this.renderShortlist(); this.querySelector('[data-copy-status]').textContent = ''; this.querySelector('[data-shortlist-text]').hidden = true; this.dialog.showModal();
      }
      if (event.target.closest('[data-shortlist-close]')) this.dialog.close();
      if (event.target.closest('[data-shortlist-copy]')) this.copy();
    }
    toggle(id) {
      if (this.selected.has(id)) this.selected.delete(id); else this.selected.add(id);
      this.cards.forEach(card => {
        const chosen = this.selected.has(card.dataset.drinkId);
        const button = card.querySelector('[data-shortlist-toggle]');
        button.classList.toggle('chosen', chosen);
        button.setAttribute('aria-pressed', String(chosen));
        card.querySelector('[data-shortlist-label]').textContent = chosen ? '✓ Added' : '+ Shortlist';
      });
      this.querySelector('[data-shortlist-dock]').hidden = this.selected.size === 0;
      this.querySelector('[data-shortlist-count]').textContent = `${this.selected.size} ${this.selected.size === 1 ? 'drink' : 'drinks'} on your shortlist`;
      if (this.dialog.open) this.renderShortlist();
    }
    renderShortlist() {
      const list = this.querySelector('[data-shortlist-items]');
      list.replaceChildren();
      for (const card of this.cards.filter(card => this.selected.has(card.dataset.drinkId))) {
        const item = document.createElement('li');
        const text = document.createElement('div');
        const name = document.createElement('strong'); name.textContent = card.dataset.name;
        const ingredients = document.createElement('span'); ingredients.textContent = card.dataset.ingredients;
        text.append(name, ingredients);
        const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.shortlistRemove = card.dataset.drinkId; remove.setAttribute('aria-label', `Remove ${card.dataset.name}`); remove.textContent = '×';
        item.append(text, remove); list.append(item);
      }
      if (this.selected.size === 0) {
        const item = document.createElement('li'); item.className = 'shortlist-empty'; item.textContent = 'Your shortlist is empty. Close this window and pick a few drinks from the menu.'; list.append(item);
      }
      this.querySelector('[data-shortlist-copy]').disabled = this.selected.size === 0;
      this.querySelector('[data-copy-status]').textContent = '';
      this.querySelector('[data-shortlist-text]').hidden = true;
    }
    async copy() {
      const text = 'The Juice. — my event menu shortlist\n\n' + this.cards.filter(card => this.selected.has(card.dataset.drinkId)).map(card => `${card.dataset.name} (${card.dataset.category}) — ${card.dataset.ingredients}`).join('\n') + '\n\nPlease confirm menu availability, smoothie bases and allergen details for my event.';
      const output = this.querySelector('[data-shortlist-text]'); output.value = text;
      try {
        await navigator.clipboard.writeText(text);
        this.querySelector('[data-copy-status]').textContent = 'Menu copied. Add it to your enquiry.';
      } catch {
        output.hidden = false; output.focus(); output.select();
        this.querySelector('[data-copy-status]').textContent = 'Select and copy the menu text below to include it in your enquiry.';
      }
    }
  }

  class JuiceShop extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.query = this.querySelector('[data-shop-query]');
      if (!this.query) return;
      this.abort = new AbortController();
      this.querySelectorAll('[data-shop-controls]').forEach(element => { element.hidden = false; });
      this.query.addEventListener('input', () => this.filter(), {signal: this.abort.signal});
      this.addEventListener('click', event => {
        if (event.target.closest('[data-shop-reset]')) { this.query.value = ''; this.filter(); }
      }, {signal: this.abort.signal});
      this.filter();
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    filter() {
      const query = this.query.value.trim().toLowerCase();
      let count = 0;
      this.querySelectorAll('[data-shop-card]').forEach(card => { card.hidden = !!query && !card.dataset.search.includes(query); if (!card.hidden) count++; });
      this.querySelector('[data-shop-count]').textContent = `${count} ${count === 1 ? 'juice' : 'juices'} on this page`;
      this.querySelector('[data-shop-empty]').hidden = count !== 0;
      this.querySelectorAll('[data-shop-reset]').forEach(button => { button.disabled = !query; });
    }
  }

  class JuiceDelivery extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const form = this.querySelector('[data-postcode-form]');
      form.hidden = false;
      form.addEventListener('submit', event => {
        event.preventDefault();
        const input = this.querySelector('[data-postcode]');
        const result = this.querySelector('[data-delivery-result]');
        const compact = input.value.toUpperCase().replace(/\s/g, '');
        result.className = 'delivery-result';
        if (!/^(GIR0AA|[A-PR-UWYZ][A-HK-Y]?\d[A-HJKPSTUW\d]?\d[ABD-HJLNP-UW-Z]{2})$/.test(compact)) {
          result.textContent = 'Enter a full UK postcode, such as CT20 1AA.'; result.classList.add('invalid'); return;
        }
        const postcode = `${compact.slice(0, -3)} ${compact.slice(-3)}`;
        input.value = postcode;
        const districts = this.dataset.districts.split(',').map(district => district.trim().toUpperCase());
        const configured = this.dataset.ordersOpen === 'true' && districts.length > 0 && districts.every(district => /^(?:[A-Z]{1,2}\d[\dA-Z]?|GIR)$/.test(district));
        if (!configured) {
          result.textContent = `Delivery coverage for ${postcode} is being confirmed. Contact us about your address before ordering.`; return;
        }
        if (districts.includes(postcode.split(' ')[0])) {
          result.textContent = 'Your postcode is within our delivery area. Your full address and available delivery options are checked at checkout.'; result.classList.add('covered');
        } else {
          result.textContent = 'This postcode is outside our current delivery area. Contact us about nearby routes or larger orders.'; result.classList.add('outside');
        }
      }, {signal: this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  }

  if (!customElements.get('juice-menu')) customElements.define('juice-menu', JuiceMenu);
  if (!customElements.get('juice-shop')) customElements.define('juice-shop', JuiceShop);
  if (!customElements.get('juice-delivery')) customElements.define('juice-delivery', JuiceDelivery);
})();
